class ModuleSmall extends Component {
  render() {
    const { title, image, author } = this.props

    return (
      <Surface
        boxShadow="0 13px 27px -5px rgba(50,50,93,.08), 0 8px 16px -8px rgba(0,0,0,.1), 0 -6px 16px -6px rgba(0,0,0,.025)"
        padding={10}
        background="white"
        borderRadius={6}
        style={{ border: "1px solid rgba(0, 0, 0, 0.2)" }}
        alignSelf="center"
        flexFlow="row"
      >
        {image}

        <Surface marginLeft={10}>
          <Text size={600} fontWeight={400}>
            {title}
          </Text>
          <Text size={400} fontWeight={600}>
            {author}
          </Text>
        </Surface>
      </Surface>
    )
  }
}

class Module extends Component {
  render() {
    const { title, text, author, image } = this.props

    return (
      <Surface marginY={10}>
        <Surface
          boxShadow="0 13px 27px -5px rgba(50,50,93,.08), 0 8px 16px -8px rgba(0,0,0,.1), 0 -6px 16px -6px rgba(0,0,0,.025)"
          paddingX={30}
          paddingY={15}
          background="white"
          borderRadius={6}
          style={{ border: "1px solid rgba(0, 0, 0, 0.2)" }}
          width={650}
          alignSelf="center"
        >
          <Surface flexFlow="row" justifyContent="space-between">
            <Text size={600} fontWeight={400} marginY={15}>
              {title}
            </Text>
            <Surface flexFlow="row" alignItems="center">
              <img
                src={image}
                width={20}
                height={20}
                style={{ borderRadius: 20 }}
              />
              <Surface marginLeft={8}>
                <Text size={500} fontWeight={600}>
                  {author}
                </Text>
              </Surface>
            </Surface>
          </Surface>
          <Surface>{text}</Surface>
        </Surface>
      </Surface>
    )
  }
}

import { range } from "lodash"

export default class New extends Component {
  render() {
    return (
      <Surface width="100%">
        <Surface
          background="rgba(245,250,253,1)"
          paddingX={70}
          paddingY={40}
          height={500}
        >
          <Surface flexFlow="row">
            <Text size={600} fontWeight={600}>
              Neural Circuits
            </Text>
            <Text size={600} fontWeight={500} marginLeft={10} opacity={0.7}>
              Overview
            </Text>
          </Surface>
        </Surface>
        <Surface
          background="white"
          boxShadow="0px -5px 20px rgba(0, 0, 0, 0.04)"
        >
          <Surface>
            <Text paddingY={30} marginX={70} size={600} fontWeight={600}>
              Vision Models
            </Text>
            <Surface>
              {range(9).map(layer => (
                <Surface
                  width="100%"
                  height={150}
                  background="rgba(230,235,241,1)"
                  style={{ borderBottom: `1px solid rgba(0, 0, 0, 0.3)` }}
                >
                  <Text margin={20} marginX={70} size={600}>
                    Layer {layer}
                  </Text>
                </Surface>
              ))}
            </Surface>
          </Surface>
        </Surface>
      </Surface>
    )
  }
}

/*
            <ModuleSmall
              author="Nick Cammarata"
              image={
                <img
                  width={iconSize}
                  height={iconSize}
                  style={{ borderRadius: iconSize }}
                  src="https://storage.googleapis.com/fls/nickc/neuron_renders/mixed3b_379.jpg"
                />
              }
              // image={require("./images/curv.png")}
              title="Curve Detectors"
            />
            <ModuleSmall
              author="Nick Cammarata"
              // image={<img src={require("./images/frequency.png")}/> }
              image={
                <img
                  width={iconSize}
                  height={iconSize}
                  style={{ borderRadius: iconSize }}
                  src="https://storage.googleapis.com/fls/nickc/neuron_renders/mixed3b_379.jpg"
                />
              }
              title="High-low Frequency Detectors"
            />

            <ModuleSmall
              author="Chris Olah"
              image={
                <img
                  width={iconSize}
                  height={iconSize}
                  style={{ borderRadius: iconSize }}
                  src="https://storage.googleapis.com/fls/nickc/neuron_renders/mixed3b_379.jpg"
                />
              }
              // image={<img src={require("./images/frequency.png")}/> }
              title="Orientation of Dog Heads"
            />
*/
